export default "/images/vendor/flag-icon-css/flags/4x3/lr.svg?3a7c494b08f2d0e36a4f5452e3919c92";